module.exports = __webpack_public_path__ + "img/mobile-49.7e362578.png";